module.exports = __webpack_public_path__ + "static/profile-daniel-milnes-ea66c7b77e9fd0cf3eb0a41e550faba3.jpg";